module.exports = __webpack_public_path__ + "static/media/claimHistory.c436c3fe.svg";